import styled from "styled-components";

export const PresentationContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 3rem 3rem 1rem;
  //position: relative;
  background-color: ${(params) => (params.light ? "#fff" : "#071242")};
`;

export const PresentationContent = styled.div`
  max-width: 1040px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

export const PresentationHeadling = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: baseline;
  justify-content: start;
  margin-bottom: 1.5rem;
`;

export const PresentationHeader = styled.h1`
  color: #fff;
  font-size: 3rem;
  font-weight: bold;

  margin-bottom: 1.5rem;
`;

export const Container = styled.div`
  width: 100%;
  height: 166px;
  padding: 20px 3rem;
  background: #071242;
  display: flex;
  align-items: center;

  header {
    font-size: 3rem;
    color: #fff;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: start;
    font-weight: bold;
    margin: 0 auto;
    max-width: 1040px;
  }

  //p {
  //  color: #fff;
  //  font-size: 20px;
  //
  //  margin-left: auto;
  //  margin-right: auto;
  //  margin-top: 10px;
  //  max-width: 1040px;
  //}

  @media screen and (max-width: 820px) {
    //p {
    //  font-size: 18px;
    //  text-align: justify;
    //}
    header {
      text-align: start;
      font-size: 23px;
    }
  }
  @media screen and (max-width: 561px) {
    height: fit-content;
  }
`;
